module.exports = __webpack_public_path__ + "img/horizontal_6_6_8019.f6eb9178.png";